module.exports = __webpack_public_path__ + "img/mix.51950c17.png";